export default [
	{
		path: "/invite",
		exact: true,
		ssr: false,
		component: "Invite",
	},
];
